import api from "./api/api";

const AdLinkServices = {
  getAdLink: async (page = 1, perPage = 10, filters: any = {}) => {
    try {
      // Construir query params
      const params = new URLSearchParams();
      params.append("page", String(page));
      params.append("perPage", String(perPage));

      if (filters.search) {
        params.append("s", filters.search);
      }
      if (filters.id_representado) {
        params.append(
          "id_representado",
          String(filters.id_representado.value || filters.id_representado)
        );
      }
      if (filters.id_criador) {
        params.append(
          "id_criador",
          String(filters.id_criador.value || filters.id_criador)
        );
      }
      // Mês e ano sempre enviados juntos
      if (filters.mes && Array.isArray(filters.mes) && filters.mes.length > 0) {
        // Verifica se tem "anual" no array
        const hasAnual = filters.mes.some(
          (m: any) => (m.value || m) === "anual"
        );

        if (hasAnual) {
          // Se for anual, envia todos os meses (1 a 12)
          params.append("mes", "1,2,3,4,5,6,7,8,9,10,11,12");
        } else {
          // Se for array de meses específicos, extrai os valores e junta com vírgula
          const mesesValues = filters.mes
            .map((m: any) => m.value || m)
            .join(",");
          if (mesesValues) {
            params.append("mes", mesesValues);
          }
        }
      } else if (filters.mes) {
        // Fallback para valor único (compatibilidade)
        params.append("mes", String(filters.mes.value || filters.mes));
      }
      if (filters.ano) {
        params.append("ano", String(filters.ano.value || filters.ano));
      }

      const res = await api.get(`/adlink/shared-desks?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getViewAdLink: async (id: any) => {
    try {
      const res = await api.get(`/adlink/shared-desks/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateSharedUsers: async (deskId: number, sharedUsers: number[]) => {
    try {
      const res = await api.put(`/adlink/shared-desks/${deskId}/shared-users`, {
        shared_users: sharedUsers,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateStatus: async (deskId: number, statusId: number) => {
    try {
      const res = await api.put(`/adlink/shared-desks/${deskId}/status`, {
        status_id: statusId,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateLinksAdLink: async (deskId: number, links: any[]) => {
    try {
      const res = await api.put(`/adlink/shared-desks/${deskId}/links-adlink`, {
        links_adlink: links,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  // Métodos para reuniões compartilhadas
  getSharedReunions: async (page = 1, perPage = 10, filters: any = {}) => {
    try {
      const params = new URLSearchParams();
      params.append("page", String(page));
      params.append("perPage", String(perPage));

      if (filters.search) {
        params.append("s", filters.search);
      }

      const res = await api.get(`/reunions/shared/list?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getSharedReunionDetail: async (id: number) => {
    try {
      const res = await api.get(`/reunions/shared/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateReunionSharedUsers: async (
    reunionId: number,
    sharedUsers: number[]
  ) => {
    try {
      const res = await api.put(`/reunions/${reunionId}/shared-users`, {
        shared_users: sharedUsers,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateReunionLinks: async (reunionId: number, links: any[]) => {
    try {
      const res = await api.put(`/reunions/${reunionId}/links`, {
        links: links,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default AdLinkServices;
